module.exports = __webpack_public_path__ + "public/img/deviceManage.4070fd7a.png";